import { $api } from "../AxiosInstance";

export class ReviewService {
  static async getAllReviews() {
    return await $api.get("/api/admin/siteReview/all");
  }

  static async getAllReviewsByLocale() {
    return await $api.get("/api/admin/siteReview/all/groupBy/locale");
  }

  static async getReviewById(id) {
    return await $api.get("/api/admin/siteReview", { params: { id } });
  }

  static async createReview(name, avatarUrl, siteName, siteUrl, text, locale) {
    return await $api.put("/api/admin/siteReview", {
      name,
      avatarUrl,
      siteName,
      siteUrl,
      text,
      locale,
    });
  }

  static async saveReview(id, name, avatarUrl, siteName, siteUrl, text, locale) {
    return await $api.post("/api/admin/siteReview", {
      id,
      name,
      avatarUrl,
      siteName,
      siteUrl,
      text,
      locale,
    });
  }

  static async deleteReview(id) {
    return await $api.delete("/api/admin/siteReview", { params: { id } });
  }
}
